import React, { useEffect, useState } from "react";
import BaseModal from "./BaseModal";
import { t } from "i18next";
import ValidationError from "../Shared/ValidationError";
import scansSchema from "../../schemas/scans.schema";
import { validate } from "../../utils/ValidationHelpers";

const FilterNameModal = ({
    isVisible,
    setIsVisible,
    submit,
    filterName,
    setFilterName,
}) => {
    const [error, setError] = useState({});
    const [isFormValid, setIsFormValid] = useState(false);
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const [isFormSubmitting, setIsFormSubmitting] = useState(false);

    useEffect(() => {
        validate(
            { filterName },
            scansSchema.ScanFilterNameSchema,
            setIsFormValid,
            setError
        );
    }, [filterName]);

    useEffect(() => {
        if (!isVisible) resetForm();
    }, [isVisible]);

    const resetForm = () => {
        setFilterName("");
        setError({});
        setIsFormValid(false);
        setIsFormSubmitted(false);
        setIsFormSubmitting(false);
    };

    const returnErrorMessages = (propName) => {
        return isFormSubmitted && error[propName];
    };

    const handleSubmit = () => {
        setIsFormSubmitted(true);
        if (isFormValid && submit) submit();
    };

    return (
        <BaseModal
            isVisible={isVisible}
            setIsVisible={setIsVisible}
            isSubmitting={isFormSubmitting}
            title={t("editFilterName")}
            titleIcon="fas fa-edit"
            action={{
                submitAction: handleSubmit,
            }}
            isSmall
        >
            <div className="input-group">
                <label className="uppercase">{t("scanFilterName")}</label>
                <div className="main-customer-form-inputs">
                    <input
                        type="text"
                        name="filterName"
                        value={filterName}
                        onChange={(e) => setFilterName(e.target.value)}
                        placeholder={t("scanFilterName")}
                        className="input-element"
                    />
                    <ValidationError
                        errorMessage={returnErrorMessages("filterName")}
                    />
                </div>
            </div>
        </BaseModal>
    );
};

export default FilterNameModal;
